<template>
  <el-table :data="recipes" style="width: 100%" :default-sort = "{ prop: 'name', order: 'ascending' }" empty-text="No associated recipes were found.">
    <el-table-column label="Recipe">
      <template slot-scope="props">
        <router-link :to="{ name: 'recipes-id', params: { id: props.row.id } }">{{ props.row.title }}</router-link>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    recipes: Array,
  },
}
</script>
